<template>
    <div>
        <el-dialog class="dialogDiv" :close-on-click-modal="false" :modal-append-to-body='false' :title="dialogTitle" :visible.sync="configDialogVisible" :before-close="handleCloseDialog">
            <el-form :model="configAdd" :rules="dataRules" ref="configAdd" v-loading="formLoading" class="ml20 mr20" label-position="left" label-width="120px">
                <el-form-item label="域名" prop="domainName">
                    <div v-if="configData.type === 'isDetail'">{{configAdd.domainName ? configAdd.domainName : '暂无'}}</div>
                    <el-input v-else v-model="configAdd.domainName" placeholder="请输入域名"></el-input>
                </el-form-item>
                <el-form-item label="系统全称" prop="fullName">
                    <div v-if="configData.type === 'isDetail'">{{configAdd.fullName ? configAdd.fullName : '暂无'}}</div>
                    <el-input v-else v-model="configAdd.fullName" placeholder="请输入系统全称"></el-input>
                </el-form-item>
                <el-form-item label="系统简称" prop="simpleName">
                    <div v-if="configData.type === 'isDetail'">{{configAdd.simpleName ? configAdd.simpleName : '暂无'}}</div>
                    <el-input v-else v-model="configAdd.simpleName" placeholder="请输入系统简称"></el-input>
                </el-form-item>
                <!-- <el-form-item label="版权声明" prop="copyright">
                    <div v-if="configData.type === 'isDetail'">{{configAdd.copyright ? configAdd.copyright : '暂无'}}</div>
                    <el-input v-else v-model="configAdd.copyright" placeholder="请输入版权声明"></el-input>
                </el-form-item>
                <el-form-item label="备案信息" prop="recordInfo">
                    <div v-if="configData.type === 'isDetail'">{{configAdd.recordInfo ? configAdd.recordInfo : '暂无'}}</div>
                    <el-input v-else v-model="configAdd.recordInfo" placeholder="请输入备案信息"></el-input>
                </el-form-item> -->
                <el-form-item label="登录前背景图片" prop="beforeBg">
                    <div class="pic" v-if="configData.type === 'isDetail'">
                      <el-image v-if="configAdd.beforeBgUrl" :src="configAdd.beforeBgUrl" @click="preview(configAdd.beforeBgUrl)" fit="cover"></el-image>
                      <el-image v-else :src="imgnull" fit="cover"></el-image>
                    </div>
                    <div class="uploadPic" v-else>
                        <upload-img @getImgUrl="getBeforeBgUrl" :echoImgUrl="configAdd.beforeBgUrl"></upload-img>
                    </div>
                </el-form-item>
                <!-- <el-form-item label="登录后背景图片" prop="afterBg">
                    <div class="pic" v-if="configData.type === 'isDetail'">
                      <el-image v-if="configAdd.afterBgUrl" :src="configAdd.afterBgUrl" @click="preview(configAdd.afterBgUrl)" fit="cover"></el-image>
                      <el-image v-else :src="imgnull" fit="cover"></el-image>
                    </div>
                    <div class="uploadPic" v-else>
                        <upload-img @getImgUrl="getAfterBgUrl" :echoImgUrl="configAdd.afterBgUrl"></upload-img>
                    </div>
                </el-form-item> -->
                <el-form-item label="登录前Logo图片" prop="beforeLogo">
                    <div class="pic" v-if="configData.type === 'isDetail'">
                      <el-image v-if="configAdd.beforeLogoUrl" :src="configAdd.beforeLogoUrl" @click="preview(configAdd.beforeLogoUrl)" fit="cover"></el-image>
                      <el-image v-else :src="imgnull" fit="cover"></el-image>
                    </div>
                    <div class="uploadPic" v-else>
                        <upload-img @getImgUrl="getBeforeLogoUrl" :echoImgUrl="configAdd.beforeLogoUrl"></upload-img>
                    </div>
                </el-form-item>
                <el-form-item label="登录后Logo图片" prop="afterLogo">
                    <div class="pic" v-if="configData.type === 'isDetail'">
                      <el-image v-if="configAdd.afterLogoUrl" :src="configAdd.afterLogoUrl" @click="preview(configAdd.afterLogoUrl)" fit="cover"></el-image>
                      <el-image v-else :src="imgnull" fit="cover"></el-image>
                    </div>
                    <div class="uploadPic" v-else>
                        <upload-img @getImgUrl="getAfterLogoUrl" :echoImgUrl="configAdd.afterLogoUrl"></upload-img>
                    </div>
                </el-form-item>
            </el-form>
            <div class="big-pic">
              <div v-if="bigImgVisable" class="modal" @click.stop="bigImgVisable = false;">
              <img :src="bigImgUrl" alt="" class="big-img">
            </div>
            </div>
            <div v-if="configData.type !== 'isDetail'" class="footer">
                <el-button @click="cancle" round>关闭</el-button>
                <el-button type="primary" @click="submit('configAdd')" round>保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import * as homeConfigApi from '@/api/homeConfig'
import UploadImg from "components/UploadImg"
export default {
    name: 'HomeConfigDialog',
    components: {
        UploadImg
    },
    data() {
        return {
            dialogTitle: '添加首页配置',
            dialogVisible: false,
            formLoading: false,
            bigImgVisable: false,
            imgnull: require('../../assets/images/imgnull.png'),
            bigImgUrl: '',
            configAdd: {
                afterBgUrl: "",
                afterLogoUrl: "",
                beforeBgUrl: "",
                beforeLogoUrl: "",
                copyright: "",
                domainName: "",
                fullName: "",
                id: "",
                recordInfo: "",
                simpleName: ""
            },
            echoFileId: '',
            dataRules: {
                domainName: [
                    { required: true, message: '请输入域名', trigger: 'blur' }
                ],
                fullName: [
                    { required: true, message: '请输入系统全称', trigger: 'blur' }
                ],
                simpleName: [
                    { required: true, message: '请输入系统简称', trigger: 'blur' }
                ]
            }
        }
    },
    props: {
        configDialogVisible: {
            required: true,
            type: Boolean
        },
        configData: {
            type: Object,
            required: true
        }
    },
    methods: {
        getBeforeBgUrl(url) {
            this.configAdd.beforeBgUrl = url;
        },
        getAfterBgUrl(url) {
            this.configAdd.afterBgUrl = url;
        },
        getBeforeLogoUrl(url) {
            this.configAdd.beforeLogoUrl = url;
        },
        getAfterLogoUrl(url) {
            this.configAdd.afterLogoUrl = url;
        },
        preview(src) {
            this.bigImgUrl = src;
            this.bigImgVisable = true;
        },
        getDetail() {
            this.formLoading = true;
            this.configAdd.id = this.configData.id;
            this.configAdd.domainName = this.configData.domainName;
            let queryData = {
              domainName: this.configAdd.domainName,
              id: this.configAdd.id
            }
            homeConfigApi.getHomeConfigDetail(queryData).then(r=>{
                if(r.code === 200) {
                    this.configAdd = r.data;
                    this.formLoading = false;
                }
            })
        },
        submit(configAdd) {
            this.$refs[configAdd].validate((valid) => {
                if (valid) {
                    if(this.configData.type === 'isAdd') {
                        homeConfigApi.addHomeConfig(this.configAdd).then(r=>{
                            if(r.code === 200) {
                                this.$message.success('添加成功!')
                                this.$parent.getConfigList();
                                this.handleCloseDialog();
                            }
                        }).catch(e=>{})
                    } else if(this.configData.type === 'isEdit') {
                        homeConfigApi.updateHomeConfig(this.configAdd).then(r=>{
                            if(r.code === 200) {
                                this.$message.success('编辑成功!')
                                this.$parent.getConfigList();
                                this.handleCloseDialog();
                            }
                        }).catch(e=>{})
                    }
                };
            });
        },
        cancle() {
            this.handleCloseDialog();
        },
        handleCloseDialog() {
            this.$emit('closeConfigDialog');
        }
    },
    mounted() {
        this.bigImgVisable = false;
        this.bigImgUrl = '';
        if(this.configData.type === 'isAdd') { // 添加
            this.configAdd = {
                afterBgUrl: "",
                afterLogoUrl: "",
                beforeBgUrl: "",
                beforeLogoUrl: "",
                copyright: "",
                domainName: "",
                fullName: "",
                recordInfo: "",
                simpleName: ""
            }
        } else if(this.configData.type === 'isEdit') { // 编辑
            this.dialogTitle = '编辑首页配置';
            this.getDetail();
        } else if(this.configData.type === 'isDetail') { // 详情
            this.dialogTitle = '首页配置详情';
            this.getDetail();
        }
    }
}
</script>

<style lang="scss" scoped>
    .dialogDiv::v-deep .el-dialog{
        .el-dialog__body {
            height: 600px;
            overflow-y: auto;
        }
    } 
    .uploadPic {
        width: 180px;
        display: inline-block;
        margin-bottom: 30px;
        color: #33393F;
        p {
            width: 360px;
            color: #8A96A1;
        }
    }
    .pic {
        .el-image {
            width: 122px;
            height: 122px;
            border-radius: 4px;
            cursor: pointer;
        }
    }
    .big-pic {
      .modal {
          position: fixed;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          z-index: 990;
          display: flex;
          justify-content: center;
          align-items: center;
          .big-img {
            max-width: 800px;
          }
      }
    }
        
    .footer {
        margin-top: 20px;
        text-align: right;
    }
</style>